var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_385",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28859",
    "data-name": "Group 28859",
    transform: "translate(-4777 6376)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4777, -6376)",
    filter: "url(#Ellipse_385)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385-2",
    "data-name": "Ellipse 385",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_14_",
    "data-name": "svgexport-17 (14)",
    transform: "translate(4791 -6358.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49709",
    "data-name": "Path 49709",
    d: "M29,28V44.58",
    transform: "translate(-5.996 -12.015)",
    fill: "none",
    stroke: "#556080",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(15 0.565)",
    fill: "#dd352e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(18 3.565)",
    fill: "#f76363"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.f5d4c5fe5fd8ec7cd6b7500e58a6a660.svg";
export { ForwardRef as ReactComponent };